<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'categoryList' }"> {{$t('entities.player.plural')}} </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'categoryShow', params: { id: model.id } }" v-if="model">{{ model.name }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title"> {{$t('entities.player.singular')}} history</h2>

    <el-form @submit.native.prevent class="search" :inline="true">
      <el-form-item>
        <el-input v-model="pager.search" :placeholder="$t('table.search')">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-table
      :data="pager.paginate(list)"
      :default-sort="{
        prop: 'modified',
        order: 'descending'
      }"
      empty-text="There is no history yet"
      @sort-change="(args) => pager.sortChange(args)"
      style="width: 100%"
      v-loading="loading"
      border
    >
      <el-table-column
        prop="modified"
        label="Updated at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.modified | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Updated by"
        prop="modifiedBy.email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="name"
        label="Name"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="created"
        label="Created at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.created | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Created by"
        prop="createdBy.email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="deleted"
        label="Deleted at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.deleted | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Deleted by"
        prop="deletedBy.email"
        sortable="custom"
      ></el-table-column>
    </el-table>

    <div class="mt-3">
      <el-pagination
        style="float: right"
        @size-change="(args) => pager.pageSizeChange(args)"
        :current-page.sync="pager.currentPage"
        :layout="paginationLayout"
        :total="pager.filteredAndSortedList(list).length"
        background
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-category-history-single',

  props: {
    id: String,
  },

  computed: {
    ...mapGetters({
      loading: 'entities/category/historySingle/loading',
      list: 'entities/category/historySingle/list',
      pager: 'entities/category/historySingle/pager',
      model: 'entities/category/historySingle/model',
      paginationLayout: "shared/paginationLayout"
    }),
  },

  created() {
    this.$store.dispatch(
      'entities/category/historySingle/setup',
      this.id,
    );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(
      'entities/category/historySingle/clear',
    );
    next();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/category/category-history/category-history-single/category-history-single.vue?6ae7d97e